// extracted by mini-css-extract-plugin
module.exports = {"loading-page":"Loading_loading-page__3nmMQ","loader":"Loading_loader__fHWHo","spin":"Loading_spin__27TzB"};